// Lecture du statut HTTP porté par une erreur de query Wasp.
//
// `handleApiError` (wasp/api) enveloppe les réponses d'erreur dans un
// WaspHttpError qui expose `statusCode`. Une panne réseau, elle, est propagée
// telle quelle et n'a donc pas de statusCode.
//
// Cette distinction est le cœur du correctif : CustomPageView traitait toute
// absence de données comme "page introuvable" et redirigeait vers /dashboard,
// éjectant aussi les utilisateurs dont la requête avait simplement échoué.

/** Statut HTTP porté par l'erreur, si c'en est une. */
export function getQueryErrorStatus(error: unknown): number | undefined {
  if (!error || typeof error !== "object") return undefined;
  const status = (error as { statusCode?: unknown }).statusCode;
  return typeof status === "number" ? status : undefined;
}

/**
 * La ressource est-elle définitivement inaccessible ?
 *
 * 404 (supprimée) et 403 (pas la nôtre) justifient une redirection. Une erreur
 * serveur ou réseau ne la justifie pas : la page existe peut-être toujours, et
 * l'utilisateur doit pouvoir réessayer plutôt que d'être éjecté.
 */
export function isMissingResource(error: unknown): boolean {
  const status = getQueryErrorStatus(error);
  return status === 404 || status === 403;
}
